import React, { useState, useRef, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import "./SingleDropdown.css";

const SingleDropdown = ({
  label = "",
  options = [],
  selectedOption,
  onSelect,
  isReadOnly,
  search = false,
  handleClickUpdate,
  extraProps,
  fieldkey,
  required,
  noLabel = "true",
  bold="true",
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const handleSelect = (option) => {
    console.log(option);
    onSelect(option);
    setShowDropdown(false);
    setSearchTerm("");
    if (extraProps) {
      handleClickUpdate(fieldkey,label, option);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (showDropdown && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [showDropdown]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const filteredOptions = options.filter((option) =>
  //   option.label.toLowerCase().includes(searchTerm.toLowerCase())
  // );
 
  const filteredOptions = options.filter(option => {
    const labelMatches = option.label.toLowerCase().includes(searchTerm.toLowerCase());
    const statusMatches = option.status === undefined || option.status === 1;
    return labelMatches && statusMatches;
  });

  return (
    <div className="dropdown-container">
      <label
        htmlFor="dropdown"
        className={`fc15 ${bold && "fw6"} fs14 mb12 ls1`}
      >
        {label && noLabel && label}
        {required && <span className="fc5">*</span>}
      </label>
      <div className="role-dropdown pr w100" ref={dropdownRef}>
        <div
          className={`selected-role aic df jcsb cp bg1 br4 h40 mt8 fs14${
            isReadOnly ? " bg4" : ""
          }`}
          onClick={() => !isReadOnly && setShowDropdown(!showDropdown)}
        >
          {selectedOption?.label || `${label && `${label}`}` || "Select"}
          <FaAngleDown className="fc16 fs14" />
        </div>
        {showDropdown && (
          <div className="dropdown-content searching-drop pa l0 r0 bg1">
            {search && (
              <input
                ref={searchInputRef}
                type="text"
                className="search-input"
                placeholder={`Search ${label}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            )}
            <ul className="single-options fs14 pa bg1 w100">
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <li key={option.value} onClick={() => handleSelect(option)}>
                    {option.label}
                  </li>
                ))
              ) : (
                <li className="no-results">No results found</li>
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default SingleDropdown;
